import { url } from "APIs/URLS";
import axios from "axios";
import { toast } from "react-hot-toast";

export const LoginAPICall = async user => {
  try {
    const promise = axios.post(`${url}/auth/login/`, {
      email: user.email,
      password: user.password,
    });
    toast.promise(promise, {
      loading: "Logging in...",
      success: "Logged in successfully",
      error: "Login failed",
    });
    const response = await promise;
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = ", error);
    throw error;
  }
};
